export default class Log {
    static COLORS = {
        LOG: '#4285F4', // Blue
        INFO: '#0F9D58', // Green
        WARN: '#FFA700', // Yellow
        ERROR: '#DB4437', // Red
    };

    static formatLogMessage(className, level, message) {
        return `%c PRIME AI FCBP %c ${className} %c ${message} %c`;
    }

    static w(className, level, message) {
        if (!window.__PRIME_AI__.debugMode) return [];
        const formattedMessage = Log.formatLogMessage(className, level, message);
        const color = Log.COLORS[level] || Log.COLORS.LOG;

        return [
            formattedMessage,
            'background:#35495e; padding: 1px; border-radius: 3px 0 0 3px;  color: #fff',
            'background:#FF5733; padding: 1px; border-radius: 0 0 0 0;  color: #fff',
            `background:${color}; padding: 1px; border-radius: 0 3px 3px 0;  color: #fff`,
            'background:transparent',
        ];
    }
}
